import { render, staticRenderFns } from "./AmountDetailDia.vue?vue&type=template&id=245ff15b&scoped=true"
import script from "./AmountDetailDia.vue?vue&type=script&lang=js"
export * from "./AmountDetailDia.vue?vue&type=script&lang=js"
import style0 from "./AmountDetailDia.vue?vue&type=style&index=0&id=245ff15b&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ff15b",
  null
  
)

export default component.exports